import React from 'react';

const CustomFontSelect = ({ value, options, onChange }) => {
    return (
        <select value={value} onChange={(e) => onChange(e.target.value)}>
            {options.map((option) => (
                <option key={option.value} value={option.value} style={{ fontFamily: option.value }}>
                    {option.label}
                </option>
            ))}
        </select>
    );
};

export default CustomFontSelect;